import React, { useState } from "react";
import Card from "../../../components/Card/Card";
import CardBody from "../../../components/Card/CardBody";
import {
  Grid,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import TranslationWrapper, { getTranslation } from "../../../components/TranslationWrapper/TranslationWrapper";
import Button from "../../../components/CustomButtons/Button";
import SweetAlert from "react-bootstrap-sweetalert";
import InvoiceLine from "../../../licensing/Models/InvoiceLine";
import { _delete } from "../../../http";
import AuthenticationWrapper from "../../../auth/AuthenticationWrapper";
import FormTextTC from "../../../components/Forms/FormTextTC";
import { useFieldArray, useFormContext, useWatch } from "react-hook-form";
import { Link, useNavigate } from "react-router";
import { Delete, Description } from "@mui/icons-material";
import FormElement from "../../../components/JamezzTable/FormElement";
import { formatValuta } from "../../../utils";
import Subscription from "../../../licensing/Models/Subscription";

function SubsInvoiceGeneral(props) {
  const [deleteSubsInvoiceLineId, setDeleteSubsInvoiceLineId] = useState(null);
  const navigate = useNavigate();

  const infoFields = [
    "description",
    "gripp_reference",
    "type",
    "status",
    "invoice_date",
    "expire_date",
    "block_subscription_date",
    "amount",
    "amount_paid",
    "amount_discount",
    "amount_credited",
    "amount_outstanding",
    "sent_email_count",
  ];

  const status = useWatch({ name: "status" });
  const id = useWatch({ name: "id" });
  const { fields: subsInvoiceLines } = useFieldArray({ name: "subs_invoice_lines", keyName: "key" });
  const { reloadDataFromServer } = useFormContext();
  return (
    <Card>
      <CardBody style={{ padding: 16 }}>
        <Grid container spacing={1}>
          <Grid item sm={6} xs={12}>
            <h3>{getTranslation("General")}</h3>
          </Grid>
          <Grid item sm={6} xs={12}>
            {status === "CONCEPT" ? (
              <AuthenticationWrapper
                child={
                  <Button
                    color={"danger"}
                    onClick={() => {
                      _delete("core/subsInvoice/" + id).then(() => {
                        navigate("/manager/subsinvoices");
                      });
                    }}
                  >
                    Delete
                  </Button>
                }
                permissionKey={"subs_invoices.deleteInvoice"}
              />
            ) : null}
          </Grid>
          {infoFields.map((fieldKey) => {
            return <FormTextTC disabled name={fieldKey} tDefault={fieldKey} tKey={"subsInvoices." + fieldKey} />;
          })}

          <Grid item xs={12}>
            <h3>
              <TranslationWrapper tKey={"Invoice lines"} />
            </h3>
          </Grid>

          <Grid xs={12}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Title</TableCell>
                  <TableCell>Unit price</TableCell>
                  <TableCell>Amount excl. VAT</TableCell>
                  <TableCell>VAT %</TableCell>
                  <TableCell />
                </TableRow>
              </TableHead>
              <TableBody>
                {subsInvoiceLines?.map((subsInvoiceLine) => {
                  return (
                    <TableRow key={subsInvoiceLine.key}>
                      <TableCell>
                        <Typography>
                          {subsInvoiceLine.number} {subsInvoiceLine.number_suffix} {subsInvoiceLine.description}{" "}
                          {subsInvoiceLine.notes}
                        </Typography>
                        <Typography>
                          {/*     {subsInvoiceLine.start_date ? new Date(subsInvoiceLine.start_date).toLocaleDateString() : ""}{" "}
                          - {subsInvoiceLine.end_date ? new Date(subsInvoiceLine.end_date).toLocaleDateString() : ""}*/}
                          {subsInvoiceLine.start_date ? (
                            <FormElement endPoint={"core/subsInvoiceLine"} name={"start_date"} row={subsInvoiceLine}>
                              <TextField
                                label={"Start date"}
                                size={"small"}
                                style={{ margin: 5 }}
                                type={"date"}
                                variant={"outlined"}
                              />
                            </FormElement>
                          ) : (
                            ""
                          )}
                          {subsInvoiceLine.end_date ? (
                            <FormElement endPoint={"core/subsInvoiceLine"} name={"end_date"} row={subsInvoiceLine}>
                              <TextField
                                label={"End date"}
                                size={"small"}
                                style={{ margin: 5 }}
                                type={"date"}
                                variant={"outlined"}
                              />
                            </FormElement>
                          ) : (
                            ""
                          )}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <FormElement endPoint={"core/subsInvoiceLine"} name={"unit_price"} row={subsInvoiceLine}>
                          <TextField label={"Unit price"} size={"small"} style={{ margin: 5 }} variant={"outlined"} />
                        </FormElement>
                        <FormElement endPoint={"core/subsInvoiceLine"} name={"discount_amount"} row={subsInvoiceLine}>
                          <TextField label={"Discount"} size={"small"} style={{ margin: 5 }} variant={"outlined"} />
                        </FormElement>
                        {subsInvoiceLine.discount_amount > 0 ? (
                          <Typography>{formatValuta(subsInvoiceLine.total_unit_price)}</Typography>
                        ) : null}
                      </TableCell>
                      <TableCell>
                        <Typography>{formatValuta(subsInvoiceLine.amount_excl)}</Typography>
                      </TableCell>
                      <TableCell>
                        <Typography>{subsInvoiceLine.tax_rate * 100} %</Typography>
                      </TableCell>

                      <TableCell>
                        <Tooltip
                          placement={"bottom"}
                          title={
                            <>
                              <TranslationWrapper tKey={"Open"} /> <TranslationWrapper tKey={"License"} />
                            </>
                          }
                        >
                          <Link to={Subscription.editPath(subsInvoiceLine.subs_subscription_id)}>
                            <IconButton>
                              <Description />
                            </IconButton>
                          </Link>
                        </Tooltip>
                        <Tooltip
                          placement={"bottom"}
                          title={<TranslationWrapper tDefault={"Verwijderen"} tKey={"global.jamezzTable.remove"} />}
                        >
                          <Button
                            color={"danger"}
                            onClick={() => setDeleteSubsInvoiceLineId(subsInvoiceLine.id)}
                            simple
                          >
                            <Delete />
                          </Button>
                        </Tooltip>
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </Grid>
        </Grid>
      </CardBody>
      {deleteSubsInvoiceLineId > 0 ? (
        <SweetAlert
          cancelBtnText={<TranslationWrapper tDefault={"Annuleren"} tKey={"global.button.annuleren"} />}
          confirmBtnText={<TranslationWrapper tDefault={"Ok"} tKey={"global.buttons.ok"} />}
          onCancel={() => {
            setDeleteSubsInvoiceLineId(null);
          }}
          onConfirm={() => {
            InvoiceLine.get(deleteSubsInvoiceLineId).then(({ model }) => {
              model.apiDelete().then(() => {
                setDeleteSubsInvoiceLineId(null);
                reloadDataFromServer();
              });
            });
          }}
          showCancel
          style={{ display: "block", marginTop: "-100px" }}
          title={
            <TranslationWrapper
              tDefault={"Verwijderen? Weet je het zeker?"}
              tKey={"global.jamezztable.confirm.delete"}
            />
          }
          warning
        />
      ) : null}
    </Card>
  );
}

export default SubsInvoiceGeneral;
